import * as React from 'react';
import EntityReporter from '../../reporters/EntityReporter';
import AfrReporter from '../../reporters/AfrReporter';
import ConceptReporter from '../../reporters/ConceptReporter';
import AccessContactRoleReporter from '../../reporters/AccessContactRoleReporter';
import ContactsReporter from '../../reporters/ContactsReporter';

const ContextPanel = (props: any) => {
    return (
        <div>
            <EntityReporter />

            <AfrReporter />

            <ContactsReporter />

            <ConceptReporter />

            <AccessContactRoleReporter />
        </div>
    )
}

export default ContextPanel;